import {
    IConsultationDto,
    IConsultationVideoScheduleDto,
    IPatientDto,
} from '@/shared/interfaces';

export enum FormattedFieldId {
    Patient,
    Email,
    CreatedBy,
    CprNumber,
    Phone,
    ScheduledOn,
    Subject,
    Category,
    Type,
    PetName,
    PetType,
    PetSex,
    PetRace,
    PetAge,
    PetWeightInKg,
}

export interface FormattedField {
    Id: FormattedFieldId;
    Title: string;
    Value: string;
}

export interface ConfirmationDto {
    Patient: IPatientDto;
    Consultation: IConsultationDto;
    ConsultationStartTime: IConsultationVideoScheduleDto;
    IsConsultationHandledByOtherCaregiver: boolean;
    FormattedFields: FormattedField[];

    AzureToken: string | null | undefined;
    PatientPhoneNumber: string | null | undefined;
    CaregiverPhoneNumber: string | null | undefined;
}
